// Import react libs
import {
    LineChart as Chart,
    Line,
    XAxis,
    YAxis,
    Tooltip,
    ResponsiveContainer,
} from 'recharts';

// Import color
import colors from '../../utils/styles/colors';

function LineChart({
    xAxisKey = null,
    yAxisKey = null,
    data = [],
    yAxisHoverLabel = null,
}) {
    if (!data || !data.length > 0) return null;

    return (
        <ResponsiveContainer width="100%" height={400}>
            <Chart data={data} margin={{ top: 40, right: 10 }}>
                <XAxis dataKey={xAxisKey} />
                <YAxis allowDecimals={false} />
                <Tooltip formatter={(value) => [`${value}`, yAxisHoverLabel]} />
                <Line
                    type="natural"
                    dataKey={yAxisKey}
                    stroke={colors.primaryBeige}
                    strokeWidth={2}
                />
            </Chart>
        </ResponsiveContainer>
    );
}

export default LineChart;
